/**
* DevExpress Dashboard (_dx-devextreme-themes-integration.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { currentTheme } from 'devextreme/viz/themes';
export var getBaseColorScheme = () => {
    var vizTheme = currentTheme();
    return (vizTheme.indexOf('dark') !== -1) ? 'dark' : 'light';
};
